
export function getGuide(cb) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.get('/api/admin/guides')
      .then(({body: {data: {items: [guide]}}}) => cb ? cb(null, guide) : guide)
      .catch(error => cb ? cb(error) : Promise.reject(error))
    ;
  };
}

export function saveGuide({content, navigation} = {}, cb) {
  return simpleIsoFetch => () => {
    return simpleIsoFetch.post({
        route: '/api/admin/guides',
        body : {
          content,
          navigation
        }
      })
      .then(({body: {data: {items: [guide]}}}) => cb ? cb(null, guide) : guide)
      .catch(error => cb ? cb(error) : Promise.reject(error));
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/guides.js